import React, { useRef } from "react";
import CardSlider from "./CardSlider";
import { SwiperSlide } from "swiper/react";
import NavigationButton from "./SliderBtn";
import Card from "../Card";

const RelatedCourse = ({ data }) => {
  const swiperRef = useRef(null);


  return (
    <div>
      {" "}
      <CardSlider onSwiper={(swiper) => (swiperRef.current = swiper)}>
        {data.map((card, index, array) => {
          return (
            <SwiperSlide key={index} style={{ width: "fit-content" }}>
              <Card
                total_length={array.length}
                img={card.img}
                link={card.link}
                id={card._id}
                name={card.name}
                rating={card.rating}
                btnText={card.btnText}
              />
            </SwiperSlide>
          );
        })}
           
      </CardSlider>
      {data.length >= 4 && (
        <div>
          <NavigationButton swiperRef={swiperRef} type="prev" />
          <NavigationButton swiperRef={swiperRef} type="right" />
        </div>
      )}
    </div>
  );
};

export default RelatedCourse;
